import React from 'react';
import './Logo.scss';
import { ReactComponent as LogoSvg } from '../../images/logo.svg';

export default function Logo() {
    return (
        <figure className="logo" data-testid="logo">
            <LogoSvg className="logo__logomark" />
            <span className="logo__logotype">Foresight Dashboard</span>
        </figure>
    );
}
